import React from "react";
import CountUp from "react-countup";

function CountData() {
  const stats = [
    { title: "Products", count: 300 },
    { title: "Associates", count: 100 },
    { title: "Specialty Division", count: 5 },
    { title: "States Presence", count: 25 },
  ];

  return (
    <section className="main-counter-section">
      <div className="bg-counter container">
        <div className="row text-center justify-content-center align-items-center">
          {stats.map((item, idx) => (
            <div
              key={idx}
              className="col-lg-3 col-md-6 col-sm-12 mb-4 background_glass"
            >
              <div className="counter-box p-4">
                <h2 className="counter-number">
                  <CountUp end={item.count} duration={2} enableScrollSpy />+
                </h2>
                <p className="counter-title mt-2">{item.title}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default CountData;
